import apiClient from '@/services/api-client';

export default {
	getMenu() {
		return apiClient().get('/MarketingResources/GetMenu');
	},
	getResource(resourceId) {
		return apiClient().get(`/MarketingResources/${resourceId}`);
	},
};
